import React, { useState, useEffect, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

//All Loading related components
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import CommonLayout from "../Common/Layout";
import { showToast } from "../../store/actions";
import UserConnectionClass from "../../service/userConnection";

const MachineLearning = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { Workspace_id } = useParams();
  const workspace = useSelector((state) => state.workspace);

  const { Name: workspaceName } = workspace.workspace;
  const connections = workspace.connections;

  const machineLearningConnection = useMemo(
    () => connections.find((connection) => connection.Type === "SageMaker") || false,
    [connections]
  );

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!machineLearningConnection) {
      dispatch(
        showToast({
          message: "Machine Learning connection is not available!",
          type: "error",
        })
      );
      return navigate(`/my-workspaces/${Workspace_id}`);
    }

    const connectWithMachineLearning = async () => {
      setLoading(true);
      const UserConnection = new UserConnectionClass();
      const connection = await UserConnection.getMachineLearningConnection();

      const { success, data } = await UserConnection.connectMachineLearning({
        ...connection.data.Detail,
        Workspace_id,
      });

      if (success) window.open(data.auth_url, "_blank");

      setLoading(false);
      return navigate(-1);
    };

    connectWithMachineLearning();
  }, [Workspace_id, machineLearningConnection, navigate, dispatch]);

  const breadcrumbArr = useMemo(
    () => [
      { link: "/my-workspaces", displayName: "Workspaces", active: false },
      { link: `/my-workspaces/${Workspace_id}`, displayName: workspaceName, active: false },
      { link: "#", displayName: "Machine Learning", active: true },
    ],
    [Workspace_id, workspaceName]
  );

  return (
    <CommonLayout title="Machine Learning" loading={loading} breadcrumbArr={breadcrumbArr}>
      <Backdrop sx={{ backgroundColor: "transparent", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="primary" />
      </Backdrop>
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) => {
            return theme.palette.TiffanyBlue.main;
          },
          height: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      ></Box>
    </CommonLayout>
  );
};

export default MachineLearning;
